import type { RunSummary } from '@xox/shared'

/** One line about today's daily run, for the dungeon home and the Today card. */
export function runStatusLine(run: RunSummary): string {
  if (run.status === 'active') return `You are on floor ${run.floor}.`
  if (run.status === 'won') return 'You cleared the dungeon!'
  if (run.status === 'dead') return `You fell on floor ${run.floor}.`
  return `You left on floor ${run.floor}.`
}
